



























































































import {
    State,
    Action,
    Getter,
    Mutation
} from "vuex-class";
import {
    Component,
    Vue,
    Prop
} from "vue-property-decorator";
import axios from "axios";
import {
    ValidationObserver,
    ValidationProvider
} from "vee-validate";
import {
    API_URL
} from "../global";
const DEFAULT_CONTACT_FORM = {
    name: "",
    email: "",
    phone: "",
    message: "",
    subject: "",

};
@Component({
    name: "ContactForm",
    components: {
        ValidationObserver,
        ValidationProvider
    }
})
export default class ContactForm extends Vue {
    public contactform: any = JSON.parse(JSON.stringify(DEFAULT_CONTACT_FORM));
    submitted: boolean = false;
    submitSuccess: boolean = false;
    showform: boolean = false;
    resetForm() {
        this.contactform = JSON.parse(JSON.stringify(DEFAULT_CONTACT_FORM));
    }
    submitForm() {
        //   this.$validator.validate().then(valid => {
        //             if (valid) {
        axios
            .post(`${API_URL}/contact-form/`, this.contactform)
            .then((resp: any) => {
                this.submitted = true;
                this.submitSuccess = true;
            })
            .catch((err: any) => {
                this.submitted = true;
            });
        //     }
        // });
    }
    // handleScroll(event: any) {
    //     let d: any = document;
    //     let scrollpos = window.scrollY;
    //     const elem = d.querySelector('.contactform-container');
    //     const counterlist = (window.scrollY + window.innerHeight);
    //     const isHalfshown = counterlist > elem.offsetTop;
    //     const countbottom = elem.offsetTop + elem.height;
    //     const isNotscrolledPast = window.scrollY < countbottom;
    //     if (isHalfshown) {
    //         (this as any).showform = true;
    //     }

    // }
    // created() {
    //     window.addEventListener('scroll', this.handleScroll);
    // }
    // destroyed() {
    //     window.removeEventListener('scroll', this.handleScroll);
    // }
}
